module.exports = __webpack_public_path__ + "img/item-bg-heighlight.b63929b9.png";